import { getJoinRequestCountByFlow } from 'app/services/sfAuth/sfData/sfJoinRequest'
import { useEffect, useState } from 'react'
import { RootStateOrAny, useSelector } from 'react-redux'

export const usePendingJoinRequests = () => {
  const user = useSelector((state: RootStateOrAny) => state?.user)

  const [pendingJoinRequests, setPendingJoinRequests] = useState<string[] | null>(null)

  useEffect(() => {
    if (user && user.userId) {
      getJoinRequestCountByFlow().then(result => {
        const requests = result.requests || []
        setPendingJoinRequests(requests.map(obj => obj.AccountId__c))
      })
    }
  }, [user])

  return { pendingJoinRequests }
}
